import React from 'react'
import { Outlet } from "react-router-dom";

const Admin = () => {
    return (
        <Outlet />
    )
}

export default Admin
